import { useState } from "react";
import { InputText } from "primereact/inputtext";
import styles from "./PasswordInput.module.css";

const joinClasses = (...classes) => classes.filter(Boolean).join(" ");

const PasswordInput = ({
  id,
  name,
  value,
  onChange,
  placeholder,
  autoComplete,
  className,
  inputClassName,
  disabled,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={joinClasses(styles.container, className)}>
      <InputText
        id={id}
        name={name}
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className={joinClasses(styles.input, inputClassName)}
        disabled={disabled}
      />
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setVisible((prev) => !prev)}
        aria-label={visible ? "Скрыть пароль" : "Показать пароль"}
        title={visible ? "Скрыть пароль" : "Показать пароль"}
        disabled={disabled}
      >
        <i className={`pi ${visible ? "pi-eye-slash" : "pi-eye"}`} />
      </button>
    </div>
  );
};

export default PasswordInput;
